import React from 'react';
import { Message, MessageProps } from 'react-native-gifted-chat';
import { Message as MessageType } from './types';
import { SCREEN_PADDING } from '@/styles';
import { StyleSheet } from 'react-native';

export const ChatMessage: React.FC<MessageProps<MessageType>> = (props) => (
  <Message {...props} containerStyle={containerStyle} />
);

export const styles = StyleSheet.create({
  container: {
    marginLeft: SCREEN_PADDING,
    marginRight: SCREEN_PADDING,
  },
});

const containerStyle = {
  left: styles.container,
  right: styles.container,
};
